import axios from "axios";
import { GridColDef } from '@mui/x-data-grid';
import moment from 'moment';
import "i18n/config";
import i18next from "i18next";

export const get = async (row?:any) => {
    let response = await axios.get(process.env.REACT_APP_WISEVIEW_BACKEND_URL+"/organization");
    return response.data;
};

export const update = async (row:any) => {
    let response = null;
    if(!row.id) {
        response = await axios.post(process.env.REACT_APP_WISEVIEW_BACKEND_URL+"/organization/store",row);
    } else {
        response = await axios.post(process.env.REACT_APP_WISEVIEW_BACKEND_URL+"/organization/update/"+row.id,row);
    }
    return response.data;
};

export const destroy = async (id:any) => {
    let response = null;
    response = await axios.post(process.env.REACT_APP_WISEVIEW_BACKEND_URL+"/organization/delete/"+id);
    return response.data;
};

export async function getColumns(locale: string) {
  i18next.changeLanguage(locale);
  return [
    { 
      field: 'id', 
      headerName: 'ID', 
      width: 90 
    },
    {
      field: 'name',
      headerName: i18next.t('Name'),
      flex: 1,
      editable: true,
    },
    {
      field: 'size',
      headerName: i18next.t('Size'),
      flex: 1,
      editable: true,
    },
    {
      field: 'sector',
      headerName: i18next.t('Sector'),
      flex: 1,
      editable: true,
    },   
    {
      field: 'mission',
      headerName: i18next.t('Mission'),
      flex: 1,
      editable: true,
    },
    {
      field: 'created_at',
      headerName: i18next.t('Created'),
      type: 'date',
      valueGetter: params => moment(params.row.created_at).toDate(),
      valueFormatter: params => new Date(params?.value).toLocaleString(),
      flex: 1,
      maxWidth: 250,
      editable: false,
    }
  ] as GridColDef[];
}



